import { Injectable } from '@angular/core';


class TokenType {
  Email: string
  Id: string
  Image: string
  MCompanyCode: string
  MId: string
  NameOfFirmCode: string
  ParentId: string
  ParentNameOfFirm: string
  ParentRoleId: string
  RoleID: string
  RoleName: string
  UserName: string
  exp: string
  iss: string
  nameOfFirm: string
  validTill: string
}
@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {
  }

  setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  getItem(key: string) {
    return localStorage.getItem(key);
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }

  getTokenValue(tokenKey: keyof TokenType): string {
    return this.getDecryptedObj()[tokenKey];
  }

  getDecryptedObj() {
    const token = this.getItem("ADMIN_TOKEN") ?? '';
    const decrptToken: TokenType = JSON.parse(atob(token.split('.')[1]));
    return decrptToken
  }
}
